import React from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

import ProfileIcon from '../../ProfileIcon';
import { ColorHex } from '../../ProfileIcon/types';

import {
  NameText, ProfileButtonContainer, ProfileButtonLink,
} from './index.styles';

interface ProfilePillProps {
  onCloseDrawer?: () => void,
  firstName?: string,
  lastName?: string,
  profileColor?: ColorHex,
  profileImage?: string,
}

const ProfileButton = (
  { onCloseDrawer,
    firstName,
    lastName,
    profileColor,
    profileImage }: ProfilePillProps,
) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <ProfileButtonContainer>
      <ProfileButtonLink
        onClick={(e) => {
          if (!e.metaKey && !isMd && onCloseDrawer) {
            // Close drawer on mobile
            onCloseDrawer();
          }
        }}
        href="/profile?tab=profile"
        color="inherit"
        underline="none"
      >
        <ProfileIcon
          firstName={firstName}
          lastName={lastName}
          color={profileColor}
          imageUrl={profileImage}
          size={32}
        />
        <NameText variant="subtitle2">
          {firstName}
        </NameText>
      </ProfileButtonLink>
    </ProfileButtonContainer>
  );
};

export default ProfileButton;
